import { memo } from "react";

export const TextHighlight = memo(
  ({
    children,
    highlight,
  }: {
    children: string;
    highlight?: string | undefined;
  }) => {
    if (!highlight || highlight === "") {
      return <>{children}</>;
    }

    const lowerChildren = children.toLowerCase();
    const lowerHighlight = highlight.toLowerCase();
    const index = lowerChildren.indexOf(lowerHighlight);

    if (index === -1) {
      return <>{children}</>;
    }

    return (
      <>
        {children.slice(0, index)}
        <strong className="contents">
          {children.slice(index, index + highlight.length)}
        </strong>
        {children.slice(index + highlight.length)}
      </>
    );
  },
);

TextHighlight.displayName = "TextHighlight";
